// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xtbn","right":"styles_right__ZRgkD"};